export const qalort_token = "qalort_token";
export const tokenOptions = {
  path: "/",
  domain:
    process.env.NODE_ENV === "development"
      ? "localhost"
      : process.env.REACT_APP_DOMAIN,
};

export const menuLinks = [
  {
    text: "View Mentors",
    link: "/mentors",
  },
  // {
  //   text: "View Profile",
  //   link: "",
  // },
  {
    text: "Dashboard",
    link: "/dashboard",
  },
  {
    text: "Calendar",
    link: "/calendar",
  },
  {
    text: "Settings",
    link: "/settings",
  },
  {
    text: "Help",
    link: "/help-center",
  },
  {
    text: "Terms & Conditions",
    link: "/terms",
  },
  {
    text: "Privacy Policy",
    link: "/privacy",
  },
];

export const COHORT_CATEGORIES = [
  {
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.96111 9.95002C8.06111 10.175 7.96111 10.4139 7.73889 10.5389C7.51389 10.6389 7.25 10.5389 7.15 10.3167L6.86944 9.6889H4.24167L3.96111 10.3167C3.83611 10.5389 3.59722 10.6389 3.37222 10.5389C3.15 10.4139 3.05 10.175 3.15 9.95002L5.15 5.50557C5.19722 5.34724 5.38056 5.24446 5.55556 5.24446C5.73056 5.24446 5.88889 5.34724 5.96111 5.50557L7.96111 9.95002ZM4.64167 8.80002H6.46944L5.53056 6.74724L4.64167 8.80002ZM11.5556 5.6889C11.5556 5.44446 11.7556 5.24446 12 5.24446C12.2444 5.24446 12.4444 5.44446 12.4444 5.6889V10.1333C12.4444 10.3778 12.2444 10.5778 12 10.5778C11.7889 10.5778 11.6111 10.4306 11.5667 10.2333C11.2472 10.45 10.8361 10.5778 10.4444 10.5778C9.33889 10.5778 8.44444 9.68335 8.44444 8.57779C8.44444 7.47224 9.33889 6.57779 10.4444 6.57779C10.8556 6.57779 11.2389 6.70279 11.5556 6.9139V5.6889ZM10.4444 7.46668C9.83056 7.46668 9.33333 7.9639 9.33333 8.57779C9.33333 9.19168 9.83056 9.6889 10.4444 9.6889C11.0583 9.6889 11.5556 9.19168 11.5556 8.57779C11.5556 7.9639 11.0583 7.46668 10.4444 7.46668ZM0 3.46668C0 2.48474 0.795833 1.6889 1.77778 1.6889H14.2222C15.2028 1.6889 16 2.48474 16 3.46668V12.3556C16 13.3361 15.2028 14.1334 14.2222 14.1334H1.77778C0.795833 14.1334 0 13.3361 0 12.3556V3.46668ZM0.888889 3.46668V12.3556C0.888889 12.8472 1.28694 13.2445 1.77778 13.2445H14.2222C14.7139 13.2445 15.1111 12.8472 15.1111 12.3556V3.46668C15.1111 2.97585 14.7139 2.57779 14.2222 2.57779H1.77778C1.28694 2.57779 0.888889 2.97585 0.888889 3.46668Z"
          fill="#57A773"
        />
      </svg>
    ),
    title: "Marketing",
  },
  {
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.6964 4.99072L8.38391 0.115723C8.13431 -0.0378705 7.86794 -0.0392767 7.61606 0.115723L0.303562 4.99072C0.116062 5.11569 0 5.33894 0 5.56213V10.4371C0 10.6603 0.116063 10.8835 0.303594 11.0085L7.61609 15.8842C7.86569 16.0378 8.13206 16.0392 8.38394 15.8842L15.6964 11.0085C15.8839 10.8836 16 10.6603 16 10.4371V5.56213C16 5.33894 15.8839 5.11569 15.6964 4.99072ZM8.6875 1.97282L14.0714 5.56213L11.6697 7.16928L8.6875 5.17819V1.97282ZM7.3125 1.97282V5.17819L4.33034 7.16928L1.92856 5.56213L7.3125 1.97282ZM1.375 6.84785L3.09822 7.99963L1.375 9.15141V6.84785ZM7.3125 14.0264L1.92856 10.4371L4.33034 8.82997L7.3125 10.8211V14.0264ZM8 9.62463L5.57141 7.99963L8 6.37463L10.4286 7.99963L8 9.62463ZM8.6875 14.0264V10.8211L11.6697 8.82997L14.0714 10.4371L8.6875 14.0264ZM14.625 9.15141L12.9018 7.99963L14.625 6.84785V9.15141Z"
          fill="#5F5FFA"
          stroke="white"
        />
      </svg>
    ),
    title: "Product Management",
  },
  {
    icon: (
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4703_57756)">
          <path
            d="M16.1 7.59999H15.7V5.59999C15.7 4.93724 15.1628 4.39999 14.5 4.39999H13.7C13.5594 4.39999 13.425 4.43124 13.3 4.47186V3.99999C13.3 3.33724 12.7628 2.79999 12.1 2.79999H11.3C10.6375 2.79999 10.1 3.33724 10.1 3.99999V7.59999H6.9V3.99999C6.9 3.33724 6.36275 2.79999 5.7 2.79999H4.9C4.2375 2.79999 3.7 3.33724 3.7 3.99999V4.47199C3.575 4.42749 3.44 4.39999 3.3 4.39999H2.5C1.83725 4.39999 1.3 4.93749 1.3 5.59999V7.59999H0.9C0.679975 7.59999 0.5 7.77999 0.5 7.99999C0.5 8.21991 0.679975 8.39999 0.9 8.39999H1.3V10.4C1.3 11.0627 1.83725 11.6 2.5 11.6H3.3C3.44062 11.6 3.575 11.5687 3.7 11.5281V12C3.7 12.6627 4.23725 13.2 4.9 13.2H5.7C6.3625 13.2 6.9 12.6625 6.9 12V8.39999H10.1V12C10.1 12.6627 10.6372 13.2 11.3 13.2H12.1C12.7628 13.2 13.3 12.6627 13.3 12V11.528C13.425 11.5725 13.56 11.6 13.7 11.6H14.5C15.1628 11.6 15.7 11.0627 15.7 10.4V8.39999H16.1C16.32 8.39999 16.5 8.21999 16.5 7.99999C16.5 7.77999 16.32 7.59999 16.1 7.59999ZM3.7 10.4C3.7 10.6187 3.51875 10.8 3.3 10.8H2.5C2.28125 10.8 2.1 10.62 2.1 10.4V5.59999C2.1 5.38124 2.28125 5.19999 2.5 5.19999H3.3C3.52 5.19999 3.7 5.38249 3.7 5.59999V10.4ZM6.1 12C6.1 12.2187 5.91875 12.4 5.7 12.4H4.9C4.6825 12.4 4.5 12.22 4.5 12V3.99999C4.5 3.78124 4.68125 3.59999 4.9 3.59999H5.7C5.92 3.59999 6.1 3.78124 6.1 3.99999V12ZM12.5 12C12.5 12.2187 12.3188 12.4 12.1 12.4H11.3C11.0813 12.4 10.9 12.2187 10.9 12V3.99999C10.9 3.78124 11.0813 3.59999 11.3 3.59999H12.1C12.32 3.59999 12.5 3.78124 12.5 3.99999V12ZM14.9 10.4C14.9 10.6187 14.7188 10.8 14.5 10.8H13.7C13.4812 10.8 13.3 10.6187 13.3 10.4V5.59999C13.3 5.38124 13.4812 5.19999 13.7 5.19999H14.5C14.72 5.19999 14.9 5.38249 14.9 5.59999V10.4Z"
            fill="#7D2DBC"
          />
        </g>
        <defs>
          <clipPath id="clip0_4703_57756">
            <rect
              width="16"
              height="16"
              fill="white"
              transform="translate(0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
    title: "Health",
  },
  {
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.4375 2.99351C2.4375 1.34024 3.77774 0 5.43103 0H10.5675C12.2208 0 13.5611 1.34024 13.5611 2.99351C13.5611 4.04037 13.0237 4.96175 12.2097 5.49678C13.0237 6.03184 13.5611 6.95319 13.5611 8.00006C13.5611 9.65334 12.2208 10.9936 10.5675 10.9936H10.5025C9.72747 10.9936 9.02119 10.699 8.48956 10.2157V12.974C8.48956 14.6493 7.11428 16 5.44716 16C3.798 16 2.4375 14.6638 2.4375 13.0065C2.4375 11.9597 2.97483 11.0383 3.78873 10.5033C2.97483 9.96822 2.4375 9.04688 2.4375 8.00006C2.4375 6.95319 2.97488 6.03184 3.78883 5.49678C2.97488 4.96175 2.4375 4.04037 2.4375 2.99351ZM7.509 5.98709H5.43103C4.31929 5.98709 3.41806 6.88834 3.41806 8.00006C3.41806 9.1075 4.31234 10.0061 5.41816 10.013C5.42244 10.013 5.42672 10.013 5.43103 10.013H7.509V5.98709ZM8.48956 8.00006C8.48956 9.11178 9.39078 10.013 10.5025 10.013H10.5675C11.6793 10.013 12.5805 9.11178 12.5805 8.00006C12.5805 6.88834 11.6793 5.98709 10.5675 5.98709H10.5025C9.39078 5.98709 8.48956 6.88834 8.48956 8.00006ZM5.43103 10.9936C5.42672 10.9936 5.42244 10.9936 5.41816 10.9936C4.31234 11.0005 3.41806 11.899 3.41806 13.0065C3.41806 14.1141 4.33133 15.0194 5.44716 15.0194C6.58097 15.0194 7.509 14.0996 7.509 12.974V10.9936H5.43103ZM5.43103 0.980556C4.31929 0.980556 3.41806 1.88179 3.41806 2.99351C3.41806 4.10525 4.31929 5.00647 5.43103 5.00647H7.509V0.980556H5.43103ZM8.48956 5.00647H10.5675C11.6793 5.00647 12.5805 4.10525 12.5805 2.99351C12.5805 1.88179 11.6793 0.980556 10.5675 0.980556H8.48956V5.00647Z"
          fill="#F37748"
        />
      </svg>
    ),
    title: "UX Design",
    value: "uxdesign",
  },
  {
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.96111 9.95002C8.06111 10.175 7.96111 10.4139 7.73889 10.5389C7.51389 10.6389 7.25 10.5389 7.15 10.3167L6.86944 9.6889H4.24167L3.96111 10.3167C3.83611 10.5389 3.59722 10.6389 3.37222 10.5389C3.15 10.4139 3.05 10.175 3.15 9.95002L5.15 5.50557C5.19722 5.34724 5.38056 5.24446 5.55556 5.24446C5.73056 5.24446 5.88889 5.34724 5.96111 5.50557L7.96111 9.95002ZM4.64167 8.80002H6.46944L5.53056 6.74724L4.64167 8.80002ZM11.5556 5.6889C11.5556 5.44446 11.7556 5.24446 12 5.24446C12.2444 5.24446 12.4444 5.44446 12.4444 5.6889V10.1333C12.4444 10.3778 12.2444 10.5778 12 10.5778C11.7889 10.5778 11.6111 10.4306 11.5667 10.2333C11.2472 10.45 10.8361 10.5778 10.4444 10.5778C9.33889 10.5778 8.44444 9.68335 8.44444 8.57779C8.44444 7.47224 9.33889 6.57779 10.4444 6.57779C10.8556 6.57779 11.2389 6.70279 11.5556 6.9139V5.6889ZM10.4444 7.46668C9.83056 7.46668 9.33333 7.9639 9.33333 8.57779C9.33333 9.19168 9.83056 9.6889 10.4444 9.6889C11.0583 9.6889 11.5556 9.19168 11.5556 8.57779C11.5556 7.9639 11.0583 7.46668 10.4444 7.46668ZM0 3.46668C0 2.48474 0.795833 1.6889 1.77778 1.6889H14.2222C15.2028 1.6889 16 2.48474 16 3.46668V12.3556C16 13.3361 15.2028 14.1334 14.2222 14.1334H1.77778C0.795833 14.1334 0 13.3361 0 12.3556V3.46668ZM0.888889 3.46668V12.3556C0.888889 12.8472 1.28694 13.2445 1.77778 13.2445H14.2222C14.7139 13.2445 15.1111 12.8472 15.1111 12.3556V3.46668C15.1111 2.97585 14.7139 2.57779 14.2222 2.57779H1.77778C1.28694 2.57779 0.888889 2.97585 0.888889 3.46668Z"
          fill="#57A773"
        />
      </svg>
    ),
    title: "Marketing",
  },
  {
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.4065 2.015C11.988 2.015 11.5665 2.1835 11.25 2.5L4.906 8.75L4.594 9.047C4.219 9.117 3.8605 9.302 3.578 9.6095C3.1615 10.0635 3.0805 10.6195 2.922 11.2185C2.763 11.8165 2.562 12.4815 2.078 13.2185L1.578 13.9995H2.5C4.4575 13.9995 5.7475 13.0645 6.4065 12.4055L6.4215 12.3905C6.723 12.082 6.8915 11.693 6.953 11.2965L7.203 11.0615L13.547 4.8115V4.7965C13.851 4.4916 14.0218 4.07858 14.0218 3.648C14.0218 3.21741 13.851 2.80439 13.547 2.4995C13.23 2.183 12.8245 2.0145 12.406 2.0145L12.4065 2.015ZM12.4065 3C12.563 3 12.7105 3.07 12.844 3.203C13.1105 3.47 13.1105 3.827 12.844 4.094L8.328 8.5625L7.422 7.656L11.953 3.203C12.0865 3.07 12.2495 3 12.4065 3ZM6.7025 8.36L7.609 9.265L6.859 10L5.952 9.0935L6.702 8.3595L6.7025 8.36ZM4.985 10.015C5.25691 10.0247 5.51668 10.13 5.7185 10.3125C6.1075 10.6685 6.1165 11.2895 5.7035 11.7025C5.2685 12.1375 4.4995 12.6955 3.375 12.906C3.615 12.381 3.7825 11.891 3.89 11.4845C4.057 10.857 4.179 10.4265 4.3125 10.281C4.486 10.091 4.7315 10.008 4.9845 10.015H4.985Z"
          fill="#4F4FD0"
        />
      </svg>
    ),
    title: "Creative Writing",
  },
  {
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.5 4.46875C8.92188 4.5 9.33125 4.61562 9.7375 4.72813C9.7875 4.74062 9.83438 4.75313 9.88125 4.76875C10.15 4.84063 10.3062 5.11875 10.2312 5.38438C10.1594 5.65 9.88125 5.80625 9.61563 5.73125C9.54063 5.7125 9.46562 5.69062 9.39062 5.66875C9.12813 5.6 8.91875 5.50313 8.67813 5.49375C8.07812 5.40625 7.53125 5.48438 7.1375 5.65312C6.73438 5.82812 6.55625 6.0625 6.51875 6.2625C6.4625 6.56562 6.58437 6.77813 6.8375 6.94063C7.17188 7.15313 7.66563 7.29375 8.27188 7.46562L8.27812 7.44063C8.83437 7.625 9.49375 7.8125 9.97812 8.14375C10.5719 8.55313 10.8438 9.20312 10.7156 9.9125C10.5906 10.5875 10.1219 11.0375 9.53125 11.275C9.22188 11.4 8.87187 11.4719 8.5 11.4937V12.25C8.5 12.525 8.275 12.75 8 12.75C7.725 12.75 7.5 12.525 7.5 12.25V11.4406C7.24687 11.4031 6.81875 11.2781 6.4875 11.1781C6.27188 11.1125 6.05625 11.0438 5.81563 10.975C5.58125 10.8875 5.4375 10.6062 5.525 10.3156C5.6125 10.0813 5.89375 9.9375 6.15625 10.025C6.3625 10.0656 6.57187 10.1594 6.77812 10.2219C7.13125 10.3281 7.4875 10.4281 7.65625 10.4531C8.275 10.5469 8.79688 10.4938 9.15938 10.35C9.50625 10.2094 9.68125 9.99687 9.73125 9.73125C9.79062 9.40312 9.68438 9.15625 9.4125 8.96875C9.0375 8.7125 8.575 8.5875 8.13125 8.46562C8.05938 8.44375 7.9875 8.425 7.91563 8.37813C7.38125 8.25313 6.75938 8.07812 6.3 7.78125C6.04688 7.62187 5.80938 7.40312 5.65938 7.10625C5.50625 6.8 5.46563 6.45625 5.53438 6.08125C5.65313 5.43438 6.1625 4.98438 6.74062 4.73438C6.975 4.63438 7.22813 4.55937 7.47188 4.51562V3.75C7.47188 3.475 7.725 3.25 7.97188 3.25C8.275 3.25 8.5 3.475 8.5 3.75V4.46875ZM16 8C16 12.4187 12.4187 16 8 16C3.58125 16 0 12.4187 0 8C0 3.58125 3.58125 0 8 0C12.4187 0 16 3.58125 16 8ZM8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1Z"
          fill="#36D29A"
        />
      </svg>
    ),
    title: "Investment",
  },
  {
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 3H12V1.5C12 0.672813 11.3281 0 10.5 0H5.5C4.67188 0 4 0.672813 4 1.5V3H2C0.895313 3 0 3.89687 0 5V13C0 14.1047 0.895313 15 2 15H14C15.1047 15 16 14.1047 16 13V5C16 3.89687 15.1031 3 14 3ZM5 1.5C5 1.22406 5.225 1 5.5 1H10.5C10.775 1 11 1.22406 11 1.5V3H5V1.5ZM15 13C15 13.5513 14.5513 14 14 14H2C1.44875 14 1 13.5513 1 13V9H5.5V11C5.5 11.2764 5.72363 11.5 6 11.5H10C10.2764 11.5 10.5 11.2764 10.5 11V9H15V13ZM6.5 10.5V9H9.5V10.5H6.5ZM15 8H1V5C1 4.44875 1.44875 4 2 4H14C14.5513 4 15 4.44875 15 5V8Z"
          fill="#F26687"
        />
      </svg>
    ),
    title: "Business",
  },
  {
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.85313 3.14687C6.05 3.34062 6.05 3.65938 5.85313 3.85313L4.85313 4.85313C4.65938 5.05 4.34062 5.05 4.14687 4.85313C3.95 4.65938 3.95 4.34062 4.14687 4.14687L5.14687 3.14687C5.34062 2.95125 5.65938 2.95125 5.85313 3.14687ZM0 8C0 3.58125 3.58125 0 8 0C12.4187 0 16 3.58125 16 8C16 12.4187 12.4187 16 8 16C3.58125 16 0 12.4187 0 8ZM14.9281 9C14.975 8.67188 15 8.34062 15 8C15 4.43125 12.3281 1.48563 8.87813 1.05438L8.7375 1.61188C9.20625 1.49406 9.70938 1.67687 9.9875 2.09C10.3844 2.67406 10.175 3.47187 9.54375 3.7875L7.69375 4.7125C7.575 4.77187 7.5 4.89375 7.5 5.02812C7.5 5.30312 7.39062 5.56562 7.19688 5.7625L6.6125 6.34375C6.54063 6.41563 6.5 6.51562 6.5 6.61562V6.66563C6.5 6.85 6.65 7 6.83437 7C6.9375 7 7.0375 6.95 7.1 6.86562L7.43437 6.41875C7.63437 6.12812 7.94375 6 8.27188 6C8.55 6 8.81875 6.10938 9.0125 6.30625L9.10312 6.39687C9.18437 6.47813 9.31563 6.47813 9.39688 6.39687L10.4 5.39375C10.8062 4.9875 11.5 5.275 11.5 5.84688V6.14375C11.5 6.34063 11.6594 6.5 11.8562 6.5H11.9719C12.7063 6.5 13.1125 7.34687 12.6281 7.91875C12.5406 8.0625 12.5594 8.275 12.7031 8.39375L13.2 8.80625C13.35 8.93125 13.5375 9 13.7312 9H14.9281ZM14.7094 10H13.7312C13.3031 10 12.8875 9.85 12.5594 9.575L12.0625 9.1625C11.5656 8.74688 11.4438 8.04688 11.7406 7.49375C11.2094 7.45 10.7656 7.1 10.5875 6.62187L10.1031 7.10313C9.63125 7.575 8.86875 7.575 8.39688 7.10313L8.30625 7.0125C8.29688 7.00625 8.28437 7 8.275 7C8.25937 7 8.24375 7.00625 8.23438 7.01875L7.9 7.46562C7.64687 7.80312 7.25312 8 6.83437 8C6.09687 8 5.5 7.40313 5.5 6.66563V6.61562C5.5 6.22187 5.64688 5.89687 5.87813 5.6375L6.4875 5.05312C6.49688 5.04688 6.5 5.0375 6.5 5.02812C6.5 4.51562 6.79062 4.04688 7.24687 3.81562L9.09688 2.89281C9.15938 2.84781 9.21562 2.73375 9.15938 2.65031C9.1125 2.58156 9.02187 2.55719 8.95 2.56562L8.69687 2.71688C8.125 2.995 7.49063 2.47969 7.64375 1.86344L7.85938 1.00156C4.05937 1.07625 1 4.18125 1 8C1 11.8313 4.08125 14.9469 7.9 14.9719C7.72188 14.7031 7.44062 14.5 7.08437 14.5C6.57812 14.5 6.09062 14.2969 5.73125 13.9406L5.23125 13.4406C4.7625 12.9719 4.5 12.3344 4.5 11.6719V11.5719C4.5 10.7344 4.91875 9.95312 5.6125 9.49063L6.46875 8.91875C6.87813 8.64687 7.3625 8.5 7.85625 8.5H8.50937C9.10625 8.5 9.68437 8.7125 10.1375 9.10312L10.9406 9.8125C11.1062 9.93437 11.2875 10 11.4719 10C11.9438 10 12.3937 10.1594 12.7281 10.5188L12.8531 10.6469C13.0812 10.8719 13.3875 11 13.7063 11H14.325C14.4781 10.6781 14.6063 10.3438 14.7094 10ZM13.7437 12H13.7063C13.1219 12 12.5594 11.7687 12.1469 11.3531L12.0188 11.2281C11.8469 11.0812 11.6781 11 11.4719 11C11.0469 11 10.6375 10.8469 10.3156 10.5719L9.4875 9.8625C9.21562 9.62813 8.86875 9.47188 8.50937 9.47188H7.85625C7.55937 9.47188 7.26875 9.5875 7.025 9.75313L6.16875 10.3219C5.75 10.6 5.5 11.0687 5.5 11.5719V11.6719C5.5 12.0688 5.65938 12.45 5.94063 12.7312L6.44063 13.2312C6.60938 13.4031 6.81562 13.5 7.08437 13.5C7.97813 13.5 8.72813 14.1094 8.94063 14.9094C10.9281 14.6719 12.65 13.5719 13.7437 12Z"
          fill="#2D8177"
        />
      </svg>
    ),
    title: "Lifestyle",
  },
  {
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4703_57792)">
          <path
            d="M0.999996 0.5C0.999996 0.223875 1.22375 0 1.5 0H14.5C14.775 0 15 0.223875 15 0.5C15 0.77625 14.775 1 14.5 1H1.5C1.22375 1 0.999996 0.77625 0.999996 0.5ZM0.499997 2.5C0.499997 2.22375 0.723746 2 0.999996 2H15C15.275 2 15.5 2.22375 15.5 2.5C15.5 2.77625 15.275 3 15 3H0.999996C0.723746 3 0.499997 2.77625 0.499997 2.5ZM7.24999 10.125C7.24999 9.75313 7.58437 9.5 7.99999 9.5C8.41562 9.5 8.74999 9.75313 8.74999 10.125C8.74999 10.4688 8.41562 10.75 7.99999 10.75C7.58437 10.75 7.24999 10.4688 7.24999 10.125ZM3 10C3 7.79063 5.23749 6 7.99999 6C10.7625 6 13 7.79063 13 10C13 12.2094 10.7625 14 7.99999 14C5.23749 14 3 12.2094 3 10ZM7.99999 13C10.4281 13 12 11.4594 12 10C12 8.54062 10.4281 7 7.99999 7C5.57187 7 4 8.54062 4 10C4 11.4594 5.57187 13 7.99999 13ZM14.1312 4C15.1594 4 15.9406 4.88438 15.8469 5.90938L15.1 14.4094C15.0187 15.3094 14.2625 16 13.3594 16H2.64156C1.73656 16 0.980621 15.3094 0.898746 14.4094L0.125965 5.90938C0.0328092 4.88438 0.839684 4 1.86875 4H14.1312ZM1.89468 14.3188C1.92968 14.7031 2.25375 15 2.64156 15H13.3594C13.7469 15 14.0687 14.7031 14.1062 14.3188L14.8781 5.81875C14.9187 5.37812 14.5719 5 14.1312 5H1.86875C1.42781 5 1.08187 5.37812 1.12187 5.81875L1.89468 14.3188Z"
            fill="#FFC246"
          />
        </g>
        <defs>
          <clipPath id="clip0_4703_57792">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    title: "Music",
  },
  {
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.5 9.5C5.5 9.36739 5.55268 9.24021 5.64645 9.14645C5.74021 9.05268 5.86739 9 6 9H9C9.13261 9 9.25979 9.05268 9.35355 9.14645C9.44732 9.24021 9.5 9.36739 9.5 9.5V10.5C9.5 10.6326 9.44732 10.7598 9.35355 10.8536C9.25979 10.9473 9.13261 11 9 11H6C5.86739 11 5.74021 10.9473 5.64645 10.8536C5.55268 10.7598 5.5 10.6326 5.5 10.5V9.5Z"
          fill="#131332"
        />
        <path
          d="M4.5 8.75C4.5 8.55109 4.57902 8.36032 4.71967 8.21967C4.86032 8.07902 5.05109 8 5.25 8H9.75C9.94891 8 10.1397 8.07902 10.2803 8.21967C10.421 8.36032 10.5 8.55109 10.5 8.75V9H11C11.1326 9 11.2598 9.05268 11.3536 9.14645C11.4473 9.24021 11.5 9.36739 11.5 9.5V10.5C11.5 10.6326 11.4473 10.7598 11.3536 10.8536C11.2598 10.9473 11.1326 11 11 11H10.5V11.25C10.5 11.4489 10.421 11.6397 10.2803 11.7803C10.1397 11.921 9.94891 12 9.75 12H5.25C5.05109 12 4.86032 11.921 4.71967 11.7803C4.57902 11.6397 4.5 11.4489 4.5 11.25V8.75ZM10 8.75C10 8.6837 9.97366 8.62011 9.92678 8.57322C9.87989 8.52634 9.8163 8.5 9.75 8.5H5.25C5.1837 8.5 5.12011 8.52634 5.07322 8.57322C5.02634 8.62011 5 8.6837 5 8.75V11.25C5 11.3163 5.02634 11.3799 5.07322 11.4268C5.12011 11.4737 5.1837 11.5 5.25 11.5H9.75C9.8163 11.5 9.87989 11.4737 9.92678 11.4268C9.97366 11.3799 10 11.3163 10 11.25V8.75Z"
          fill="#131332"
        />
        <path
          d="M1.5 4C1.63261 4 1.75979 4.05268 1.85355 4.14645C1.94732 4.24021 2 4.36739 2 4.5H2.75C2.94891 4.5 3.13968 4.57902 3.28033 4.71967C3.42098 4.86032 3.5 5.05109 3.5 5.25V5H9C9.53035 5.00027 10.0389 5.21106 10.4139 5.58608C10.7889 5.96109 10.9997 6.46965 11 7H14.5C14.6326 7 14.7598 7.05268 14.8536 7.14645C14.9473 7.24021 15 7.36739 15 7.5V10.5C15 10.6326 14.9473 10.7598 14.8536 10.8536C14.7598 10.9473 14.6326 11 14.5 11H13V14C13 14.2652 12.8946 14.5196 12.7071 14.7071C12.5196 14.8946 12.2652 15 12 15H4.5C4.23478 15 3.98043 14.8946 3.79289 14.7071C3.60536 14.5196 3.5 14.2652 3.5 14V6.75C3.5 6.94891 3.42098 7.13968 3.28033 7.28033C3.13968 7.42098 2.94891 7.5 2.75 7.5H2C2 7.63261 1.94732 7.75979 1.85355 7.85355C1.75979 7.94732 1.63261 8 1.5 8C1.36739 8 1.24021 7.94732 1.14645 7.85355C1.05268 7.75979 1 7.63261 1 7.5V4.5C1 4.36739 1.05268 4.24021 1.14645 4.14645C1.24021 4.05268 1.36739 4 1.5 4ZM14 10.5V7.5H13V10.5H14ZM12.5 7.5H4V12.5H12.5V7.5ZM6.5 13.75C6.5 13.8163 6.52634 13.8799 6.57322 13.9268C6.62011 13.9737 6.6837 14 6.75 14H7.25C7.3163 14 7.37989 13.9737 7.42678 13.9268C7.47366 13.8799 7.5 13.8163 7.5 13.75C7.5 13.6837 7.47366 13.6201 7.42678 13.5732C7.37989 13.5263 7.3163 13.5 7.25 13.5H6.75C6.6837 13.5 6.62011 13.5263 6.57322 13.5732C6.52634 13.6201 6.5 13.6837 6.5 13.75ZM9.25 14C9.3163 14 9.37989 13.9737 9.42678 13.9268C9.47366 13.8799 9.5 13.8163 9.5 13.75C9.5 13.6837 9.47366 13.6201 9.42678 13.5732C9.37989 13.5263 9.3163 13.5 9.25 13.5C9.1837 13.5 9.12011 13.5263 9.07322 13.5732C9.02634 13.6201 9 13.6837 9 13.75C9 13.8163 9.02634 13.8799 9.07322 13.9268C9.12011 13.9737 9.1837 14 9.25 14ZM10.415 6.5C10.3115 6.20746 10.1198 5.95421 9.86643 5.77512C9.61301 5.59603 9.31031 5.49991 9 5.5H4V6.5H10.415Z"
          fill="#131332"
        />
      </svg>
    ),
    title: "Photography",
  },
  {
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.6666 6H5.33331C3.12431 6 1.33331 7.791 1.33331 10C1.33331 12.209 3.12431 14 5.33331 14H10.6666C12.8756 14 14.6666 12.209 14.6666 10C14.6666 7.791 12.8756 6 10.6666 6Z"
          stroke="#22AED1"
          strokeWidth="1.6"
          strokeLinejoin="round"
        />
        <path
          d="M5.33333 8.66668V11.3333M4 10H6.66667M8 5.33334V3.23801H10.6667V1.33334"
          stroke="#22AED1"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.6666 11.3334C11.0203 11.3334 11.3594 11.1929 11.6095 10.9428C11.8595 10.6928 12 10.3536 12 10C12 9.6464 11.8595 9.30726 11.6095 9.05721C11.3594 8.80716 11.0203 8.66669 10.6666 8.66669C10.313 8.66669 9.97389 8.80716 9.72384 9.05721C9.47379 9.30726 9.33331 9.6464 9.33331 10C9.33331 10.3536 9.47379 10.6928 9.72384 10.9428C9.97389 11.1929 10.313 11.3334 10.6666 11.3334Z"
          stroke="#22AED1"
          strokeWidth="1.6"
          strokeLinejoin="round"
        />
      </svg>
    ),
    title: "Gaming",
  },
];

export const paystack_key = "pk_test_80a57cc4b78dccff0116a73bf399562f893f410c";

export const okButtonProps = `bg-pri !text-white border-pri !rounded-[10px] !p-4 !inline-flex !justify-center !items-center`;
export const cancelButtonProps =
  "bg-white !rounded-[10px] !p-4 !inline-flex !justify-center !items-center";

export const VIDEOSDK_TOKEN =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcGlrZXkiOiJmNzBmOWFkNy05ZDIwLTRkNGItYWNhNC1kMzUzOTgwZDNmNDYiLCJwZXJtaXNzaW9ucyI6WyJhbGxvd19qb2luIl0sImlhdCI6MTcyMzgxOTI1OSwiZXhwIjoxNzU1MzU1MjU5fQ.ix3EeW3G9jWZUEQmlS9oaBjafWpK0hKH8wkzrQ_MsII";
// export const stripe_key =
//   "pk_test_51LhhQlKOC5xwZnmZmVrOyRP01mvBSB95XTO4NbjGb42Co4GaYp1MzLRVf9NEjoD1JLS3ODHjb6MGhaCFtqMuJiK800e9fxXi9S";
